// @ref https://day.js.org/docs/en/timezone/timezone
import { LanguageID } from "configs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

import { getLanDefault } from "./lan";

require("dayjs/locale/vi");

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

dayjs.extend(updateLocale);

dayjs.updateLocale("vi", {
  weekStart: 0,
});

if (getLanDefault() === LanguageID.vi) {
  dayjs.locale("vi");
}

// TODO: Update "timezone" value by getting from API
dayjs.tz.setDefault("Asia/Ho_Chi_Minh");

export const dayjsTZ = (
  date?: string | number | Date | dayjs.Dayjs | null | undefined
) => {
  return dayjs(date).tz();
};

export const dayjsTZWithDefault = (
  date?: string | number | Date | dayjs.Dayjs | null | undefined
) => {
  try {
    return dayjs(date).tz();
  } catch (error) {
    return dayjs().tz();
  }
};

export const dayjsFormatTZ = (
  date?: string | number | Date | dayjs.Dayjs | null | undefined,
  format?: dayjs.OptionType
) => {
  return dayjs(date, format).tz();
};

export const convertDateToForm = (
  date?: string | number | Date | dayjs.Dayjs | null | undefined,
  format?: dayjs.OptionType
) => {
  if (!date) return null;
  if (format) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
    return dayjs(String(date), format).tz() as any;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any
  return dayjsTZ(date).tz() as any;
};

export const convertDateFormToAPI = (
  date?: string | number | Date | dayjs.Dayjs | null | undefined,
  format?: string
) => {
  if (!date) return null as never;
  if (format) {
    return dayjsTZ(date).format(format);
  }
  return dayjsTZ(date).format("YYYY-MM-DD");
};

export const formatDateTime = (date?: string) => {
  if (!date) return "";
  return dayjs(String(date), "YYYY-MM-DD").format("DD/MM/YYYY");
};

export const dateToISOString = (
  date: string,
  type?: "startDay" | "endDate"
): string | null => {
  try {
    if (type) {
      if (type === "startDay") {
        return dayjsTZ(date).startOf("day").toISOString();
      }
      return dayjsTZ(date).endOf("day").toISOString();
    }
    return dayjsTZ(date).toISOString();
  } catch {
    return null;
  }
};

export default dayjs;
